
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/_gelderland/downloads",
      function () {
        return require("private-next-pages/_sites/_gelderland/downloads.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_sites/_gelderland/downloads"])
      });
    }
  